import { FormattedDate, FormattedMessage, FormattedTime, useIntl } from 'react-intl';

import type { Tour } from '#domain/Tour.ts';

const FormattedDateTime = ({ value }: { value: string }) => {
    return (
        <>
            <FormattedDate value={value} dateStyle={'short'} />
            <span>{' / '}</span>
            <FormattedTime value={value} />
        </>
    );
};

export const TourStopProgressHeader = ({ tour }: { tour: Tour }) => {
    const intl = useIntl();
    const firstStop = tour.firstStop;
    const lastStop = tour.lastStop;
    const hasStops = firstStop && lastStop;
    return (
        <div className='display-flex gap-5'>
            <div className='display-flex flex-column gap-3'>
                {hasStops && (
                    <div className='text-medium line-height-125rel padding-right-25'>{`${firstStop.name} -> ${lastStop.name}`}</div>
                )}
                <div className='display-flex align-items-center gap-5'>
                    {tour.status === 'planned' && (
                        <span className='rioglyph rioglyph-eye-close text-size-12 text-color-info' />
                    )}
                    {hasStops && (
                        <span className='text-size-11 text-medium'>
                            <FormattedDateTime value={firstStop.startTarget} />
                            <span>{' - '}</span>
                            <FormattedDateTime value={lastStop.endTarget} />
                        </span>
                    )}
                    <span className='display-flex align-items-center gap-3'>
                        <span className='text-size-11 text-medium'>|</span>
                        <span className='text-size-11 text-medium'>{tour.progress.finishedStopAmount}</span>{' '}
                        <span className='text-size-11 text-medium'>
                            {intl.formatMessage({
                                id: 'intl-msg:ordercom-cloud-frontend.tours.stop-details.progressHeader.stopsOf',

                                defaultMessage: 'of',
                            })}
                        </span>{' '}
                        <span className='text-size-11 text-medium'>{tour.progress.totalStopAmount} Stops</span>
                    </span>
                </div>
                {tour.status === 'problem' && (
                    <div className={'display-flex align-items-center flex-shrink-0 gap-3'}>
                        <div className='label label-danger'>
                            <span className='rioglyph rioglyph-flash' />
                            <FormattedMessage id={'intl-msg:ordercom-cloud-frontend.tour.problem.label'} />
                            {tour.problem?.type && (
                                <>
                                    <span>: </span>
                                    <FormattedMessage
                                        id={`intl-msg:ordercom-cloud-frontend.tour.problem.${tour.problem.type}`}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
